<div class="use-cases">
  <h1 class="ui-heading-1-bold use-cases-title">{{ section() }}</h1>

  <ul class="use-cases-content">
    @for (u of useCases(); track $index) {
      <li class="use-case-item">
        <h2 class="ui-heading-3">{{ u.name }}</h2>
        <p class="ui-body-l">{{ u.description }}</p>
      </li>
    }
  </ul>
</div>
